import { FC, Fragment } from "react";
import { useFormContext } from "react-hook-form";

export const RsvpFormSubmit: FC = () => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <div className="center">
      <button
        type="submit"
        className="btn btn-primary submit_form"
        disabled={isSubmitting}
      >
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        {isSubmitting ? (
          <Fragment>
            Sending...<i className="fas fa-spinner fa-spin after"></i>
          </Fragment>
        ) : (
          "Send"
        )}
      </button>
    </div>
  );
};
